export type MaxShareContentParams =
    | {
        text?: string;
        link?: string;
    }
    | {
        mid: string;
        chatType: "DIALOG" | "CHAT";
    };

export type MaxShareContentStatus = "shared" | "cancelled";

export type MaxShareContentResult = {
    status: MaxShareContentStatus;
};

type MaxWebApp = {
    shareMaxContent?: (params: MaxShareContentParams) => Promise<MaxShareContentResult>;
};

export const shareMaxContentInMax = async (params: MaxShareContentParams): Promise<MaxShareContentResult> => {
    const wa = (window as Window & { WebApp?: MaxWebApp }).WebApp;
    if (!wa || typeof wa.shareMaxContent !== "function") {
        throw new Error("MAX_SHARE_MAX_CONTENT_UNAVAILABLE");
    }

    return await wa.shareMaxContent(params);
};

